import type React from 'react';

export interface DenialSupportIconProps {
	width?: string | number;
	height?: string | number;
	color?: string;
	'aria-label'?: string;
}

const DenialSupportIcon: React.FC<DenialSupportIconProps> = ({
	width = 25,
	height = 25,
	'aria-label': ariaLabel = 'Denial Support Icon',
	color = 'currentColor',
}) => (
	<svg
		width={width}
		height={height}
		aria-label={ariaLabel}
		viewBox="0 0 64 64"
		fill="none"
		color={color}
		xmlns="http://www.w3.org/2000/svg"
	>
		{/* Full Support Headset (background) */}
		<path
			d="M16 34C16 21.85 25.85 12 38 12C50.15 12 60 21.85 60 34"
			stroke="currentColor"
			stroke-width="3"
			stroke-linecap="round"
		/>
		<rect
			x="12"
			y="32"
			width="8"
			height="18"
			rx="3"
			stroke="currentColor"
			stroke-width="3"
		/>
		<rect
			x="56"
			y="32"
			width="8"
			height="18"
			rx="3"
			stroke="currentColor"
			stroke-width="3"
		/>
		<path
			d="M32 52C32 56 28 58 24 58"
			stroke="currentColor"
			stroke-width="3"
			stroke-linecap="round"
		/>

		{/* Small Invoice (overlapping foreground) */}
		<rect
			x="22"
			y="20"
			width="20"
			height="28"
			rx="2"
			stroke="currentColor"
			stroke-width="2"
		/>
		<line
			x1="25"
			y1="28"
			x2="39"
			y2="28"
			stroke="currentColor"
			stroke-width="1.5"
		/>
		<line
			x1="25"
			y1="34"
			x2="39"
			y2="34"
			stroke="currentColor"
			stroke-width="1.5"
		/>

		{/* Invalid Mark */}
		<line
			x1="26"
			y1="44"
			x2="38"
			y2="32"
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="round"
		/>
		<line
			x1="38"
			y1="44"
			x2="26"
			y2="32"
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="round"
		/>
	</svg>

);
export default DenialSupportIcon;